import { useState } from "react";
import * as Scrivito from "scrivito";

export const EditorHintForPageChanges = Scrivito.connect(({ show }) => {
  const [hidden, setIsHidden] = useState(false);

  if (hidden) {
    return null;
  }

  if (!show) {
    return null;
  }

  const currentPage = Scrivito.currentPage();
  if (!currentPage) {
    return null;
  }
  if (!currentPage.modification()) {
    return null;
  }
  const langVersions = currentPage.versionsOnAllSites();
  if (langVersions.length <= 1) {
    // Page have no language versions
    return null;
  }

  return (
    <div className="page-hints__language">
      <h5 className="mb-1">There was a change on this Page.</h5>
      Please check the other language version before the changes will be
      published
      <button
        className="btn bg-white d-block mt-3"
        onClick={() => setIsHidden(true)}
      >
        Hide
      </button>
    </div>
  );
});
